import { render, staticRenderFns } from "./RequestToPayDetailPage.vue?vue&type=template&id=28bae891&"
import script from "./RequestToPayDetailPage.vue?vue&type=script&lang=js&"
export * from "./RequestToPayDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28bae891')) {
      api.createRecord('28bae891', component.options)
    } else {
      api.reload('28bae891', component.options)
    }
    module.hot.accept("./RequestToPayDetailPage.vue?vue&type=template&id=28bae891&", function () {
      api.rerender('28bae891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/RequestToPayDetailPage.vue"
export default component.exports